import { AppContext } from "Context/AppContext";
import { AttributeContext } from "../AttributeContext";
import AppSettings from "Settings/AppSettings";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify"
import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import Label from "Components/Common/components/Label";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";
import GMSBorderlessButton from "Components/Common/components/GMSBorderlessButton";
import SmallOutlinedButton from "Components/Common/components/SmallOutlinedButton";
import BootBoxManager from "Common/BootBoxManager";
import CategoriesView from "./CategoriesView";
import AttributeValuesView from "./AttributeValuesView";
import ABSView from "./ABSView";
import AttributeConstraintView from "./AttributeConstraintView";
import GMSButton from "Components/Common/components/GMSButton";
import { TAttribute, TAttributeDetail } from "../types";
import CompatioLoader from "Components/Common/components/CompatioLoader";
import { ABS_SELECTION, CF_SELECTION } from "../AttributeConstants";

type MyProps = {
  setAttrListApiCompleted: any
}

const AttributeDetails = ({ setAttrListApiCompleted }: MyProps) => {
  const history = useHistory();
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appData = useContext(AppContext);
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry()?.id;
  const {
    editingItem,
    setEditingItem,
    setListReloadCounter,
    setDeleteInfo,
    setNewAttributeId,
    setAttributeDeleted,
  } = useContext(AttributeContext) as any;

  const [showLoader, setShowLoader] = React.useState(false);

  let [loading, setLoading] = React.useState<{
    status?: string,
    message?: string
  }>({
    status: "",
    message: "",
  });
  let [AttributeDetail, setAttributeDetail] = React.useState<TAttributeDetail | null>(null);
  const [clipText, setClipText] = useState<string | null>(null);

  function handle_clipbord(text?: string) {
    if (!text) return
    navigator.clipboard.writeText(text).then(() => setClipText(text));
    setTimeout(() => {
      setClipText(null);
    }, 2000);
  }

  function handle_url_clipbord(id?: string) {
    if (!id) return
    const url = `${window.location.origin}${window.location.pathname}`;
    const categoryID = `/${id}`;
    if (url.includes(id)) {
      navigator.clipboard
        .writeText(`${url}`)
        .then(() => toast.success("Url Copied to clipboard"));
    } else {
      navigator.clipboard
        .writeText(`${url}${categoryID}`)
        .then(() => toast.success("Url Copied to clipboard"));
    }
  }

  useEffect(() => {
    load_Attribute_detail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem.id]);

  async function load_Attribute_detail() {
    if (editingItem.id === undefined) return;
    setAttributeDetail(null);
    setLoading({ status: "Loading", message: "Loading Attribute Details" });
    if (editingItem.id === undefined) {
      return;
    }
    let res = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/attribute/list/${editingItem.id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      setAttrListApiCompleted(true);
      setLoading({ status: "Success", message: undefined });
      setAttributeDetail(res.data.data[0]);
    } else {
      setAttrListApiCompleted(true);
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  async function handle_delete_Attribute(attribute: TAttribute) {
    setShowLoader((prev) => !prev);
    setDeleteInfo({
      status: "Loading",
      message: "Deleting selected Attribute",
    });

    let res = await ServiceWrapper.doGet(
      api_base_url + "attribute/delete/" + attribute.id,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setShowLoader((prev) => !prev);
        setNewAttributeId("");
        toast.success(res.data.message);
        if (
          editingItem !== null &&
          editingItem !== undefined &&
          editingItem.id === attribute.id
        ) {
          setEditingItem(null);
        }
        setAttributeDeleted(true);
        setListReloadCounter((n: any) => n + 1);
      } else {
        setShowLoader((prev) => !prev);
        setDeleteInfo({
          status: "Error",
          message: "Deletion of Attribute Failed",
        });
        window["bootbox"].dialog({
          title: "Attribute Deletion Failure",
          message:
            "<p>We are Sorry, We could not delete the selected Attribute Below is more information.</p><p><strong>" +
            res.data.message +
            "</strong></p>",
          size: "medium",
          closeButton: false,
          centerVertical: true,
          buttons: {
            ok: {
              label: "OK, I got it",
              className: "button-fill",
              callback: function () {
                console.log("Custom OK clicked");
              },
            },
          },
        });
      }
    } else {
      setShowLoader((prev) => !prev);
      setDeleteInfo({
        status: "Error",
        message: "Error while deleting selected Attribute!!",
      });
    }
    setTimeout(() => {
      setDeleteInfo({
        status: null,
        message: "",
      });
    }, 5000);
  }

  return (
    <>
      <div>
        <div
          className="pb-2 d-flex justify-content-between align-items-center"
          style={{
            borderBottom: "1px solid #c9c9cf",
          }}
        >
          <div className="ms-4">
            <Label message="Attributes" fontSize={"1.125"} fontWeight="600" />
          </div>
          <div
            className="btn-group me-2"
            style={{
              right: "6px",
              float: "right",
            }}
          >
            <GMSButton
              name="Create"
              onClick={() => {
                if (appData.pm.checkPermission("gmsattributes_update")) {
                  if (
                    editingItem === null ||
                    editingItem.form === "view"
                  ) {
                    setEditingItem({
                      form: "edit",
                      id: "0",
                    });
                  } else {
                    setEditingItem(null);
                    setTimeout(() => {
                      setEditingItem({
                        form: "edit",
                        id: "0",
                      });
                    }, 1000);
                  }
                } else {
                  toast.success(
                    "You don't have permission to create the attribute"
                  );
                }
              }}
            />
          </div>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb ms-4 mt-2">
            <li className="breadcrumb-item tw-pointer-events-none">
              <Link to="#">
                <Label
                  message="Taxonomy"
                  fontSize={"0.75"}
                  fontWeight="400"
                  color="#5c5f62"
                />
              </Link>
            </li>
            <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
              <Label
                message="Attributes"
                fontSize={"0.75"}
                fontWeight="500"
                color="#5c5f62"
              />
            </li>
            <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
              <Label
                message={loading.status === "Success" && AttributeDetail ? AttributeDetail.name : ""}
                fontSize={"0.75"}
                fontWeight="500"
                color="#5c5f62"
              />
            </li>
          </ol>
        </nav>
      </div>
      {showLoader && (
        <div className="d-flex h-50 justify-content-center align-items-center">
          <CompatioLoader width="120px" height="120px" />
        </div>
      )}
      <LoadingSuccessErrorAlert loading={loading} />

      {loading.status === "Success" && AttributeDetail && (
        <div className=" mt-0 pb-3 px-3">
          <div className="col col-md-12 cat">
            <div className="p-3 border rounded">
              <div className="d-flex justify-content-between ps-1">
                <Label
                  message={AttributeDetail.name}
                  fontSize={"1.125"}
                  fontWeight="600"
                />
                <div className="d-flex">
                  <GMSBorderlessButton
                    name="Duplicate"
                    onClick={() => {
                      if (appData.pm.checkPermission("gmsattributes_update")) {
                        setEditingItem({
                          form: "duplicate",
                          id: AttributeDetail?.id,
                        });
                      } else {
                        toast.info(
                          "You don't have permission to duplicate the attribute"
                        );
                      }
                    }}
                  />
                  {/* } */}
                  &nbsp;&nbsp;&nbsp;
                  {/* {appData.pm.checkPermission("attributes_update") && ( */}
                  <div className="d-flex justify-content-center align-items-center">
                    <SmallOutlinedButton
                      name="Edit"
                      onClick={() => {
                        if (
                          appData.pm.checkPermission("gmsattributes_update")
                        ) {
                          setEditingItem({
                            form: "edit",
                            id: AttributeDetail?.id,
                          });
                        } else {
                          toast.info(
                            "You don't have permission to edit the attribute"
                          );
                        }
                      }}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="bd-highlight">
                      <li
                        className="nav-item dropdown"
                        style={{ listStyleType: "none" }}
                      >
                        <div role="group">
                          <i
                            id="btnGroupDrop1"
                            className="fas fa-ellipsis-v pt-1"
                            style={{
                              fontSize: "0.875rem",
                              cursor: "pointer",
                              color: "#091caa",
                            }}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={() => null}
                          />

                          <div className="dropdown-menu p-0 mt-3">
                            {/* <h6 class="dropdown-header">Dropdown header</h6> */}
                            <Link
                              to="#"
                              className="dropdown-item"
                              style={{ fontSize: "0.875rem" }}
                              onClick={() => {
                                if (
                                  appData.pm.checkPermission(
                                    "gmsattributes_delete"
                                  )
                                ) {
                                  BootBoxManager.confirm(
                                    "",
                                    `${AttributeDetail?.name}`,
                                    false,
                                    [handle_delete_Attribute, AttributeDetail]
                                  );
                                } else {
                                  toast.info(
                                    "You don't have permission to delete the attribute"
                                  );
                                }
                              }}
                            >
                              Delete
                            </Link>
                            <Link
                              to="#"
                              className="dropdown-item"
                              style={{ fontSize: "0.875rem" }}
                              onClick={() => {
                                handle_url_clipbord(AttributeDetail?.id);
                              }}
                            >
                              Share Url
                            </Link>
                          </div>
                        </div>
                      </li>
                    </div>
                  </div>
                  {/* )} */}
                </div>
              </div>
              <div className="ps-1">
                <p className="small mb-2">
                  <span
                    className=""
                    style={{
                      fontFamily: "Noto Sans",
                      fontWeight: 400,
                      lineHeight: 1.5,
                      color: "#000000",
                    }}
                  >
                    {" "}
                    {AttributeDetail.description}
                  </span>
                </p>
                <p className="small mt-1">
                  <span
                    style={{
                      fontSize: "0.75",
                      color: "#000000",
                      fontFamily: "Noto Sans",
                      fontWeight: "500",
                    }}
                    className=""
                  >
                    {" "}
                    UID:{" "}
                    <Label
                      message={AttributeDetail.id || ""}
                      fontSize={"0.75"}
                      fontFamily="Noto Sans"
                      fontWeight="400"
                      color="#5c5f62"
                    />
                  </span>
                  &nbsp;&nbsp;
                  <i
                    className={`${clipText === null ? "far" : "fas"
                      } fa-clipboard`}
                    style={{
                      fontSize: "0.95rem",
                      cursor: "pointer",
                      color: "#091caa",
                    }}
                    onClick={() => handle_clipbord(AttributeDetail?.id)}
                  />
                  &nbsp;&nbsp;
                  <Label
                    message={clipText === null ? "" : "UID Copied"}
                    fontSize={"0.75"}
                    color="#488328"
                  />
                </p>
              </div>
            </div>
            <br />
            <CategoriesView />
            <br />
            <AttributeValuesView />
            <br />
            <ABSView title={ABS_SELECTION} id={'Abs'} />
            <br />
            <AttributeConstraintView />
            <br />
            <ABSView title={CF_SELECTION} id={'Cf'} />
            <br />
          </div>
        </div>
      )}
    </>
  );
};



export default AttributeDetails